package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.Serializable

@Serializable
data class FeatureFlagDto(
    val key: String,
    val label: String,
    val description: String? = null,
    val enabled: Boolean,
)

@Serializable
data class UpdateFeatureFlagRequest(
    val enabled: Boolean,
)
